import BaseModelInstance from './base.model'
import { LeadCreditQuantityPrice as ModelDefinition } from './model-definitions'

class LeadCreditQuantityPrice extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default LeadCreditQuantityPrice
